__turbopack_context__.v({
  "accordionSlideOverwrite": "fileSelect-module-scss-module__A80woa__accordionSlideOverwrite",
  "bold": "fileSelect-module-scss-module__A80woa__bold",
  "container": "fileSelect-module-scss-module__A80woa__container",
  "error": "fileSelect-module-scss-module__A80woa__error",
  "fadeIn": "fileSelect-module-scss-module__A80woa__fadeIn",
  "fadeOut": "fileSelect-module-scss-module__A80woa__fadeOut",
  "fileName": "fileSelect-module-scss-module__A80woa__fileName",
  "fileSelect": "fileSelect-module-scss-module__A80woa__fileSelect",
  "icon": "fileSelect-module-scss-module__A80woa__icon",
  "label": "fileSelect-module-scss-module__A80woa__label",
  "previewImage": "fileSelect-module-scss-module__A80woa__previewImage",
  "removeButton": "fileSelect-module-scss-module__A80woa__removeButton",
  "scaleIn": "fileSelect-module-scss-module__A80woa__scaleIn",
  "scaleOut": "fileSelect-module-scss-module__A80woa__scaleOut",
  "zoomIn": "fileSelect-module-scss-module__A80woa__zoomIn",
  "zoomOut": "fileSelect-module-scss-module__A80woa__zoomOut",
});
